import React from 'react';

export const SponsorsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 3.33333C0 1.49238 1.49238 0 3.33333 0H16.6667C18.5076 0 20 1.49238 20 3.33333V16.6667C20 18.5076 18.5076 20 16.6667 20H3.33333C1.49238 20 0 18.5076 0 16.6667V3.33333Z"
        fill="#333333"
      />
      <path
        d="M14.4086 9.97934L9.99972 14.3882L5.59082 9.97934L9.99972 5.57129L14.4086 9.97934ZM10.0002 13.2409L13.2609 9.97934L10.0002 6.71862L6.73858 9.97934L10.0002 13.2409Z"
        fill="white"
      />
      <path
        d="M14.1219 12.5434L10.0001 16.6651L5.87793 12.5434L6.45181 11.9695L10.0001 15.5173L13.5475 11.9695L14.1219 12.5434Z"
        fill="white"
      />
      <path
        d="M14.1219 7.45671L13.5475 8.03059L10.0001 4.48272L6.45181 8.03059L5.87793 7.45671L10.0001 3.33496L14.1219 7.45671Z"
        fill="white"
      />
    </svg>
  );
};
